import React from "react"
import PropTypes from "prop-types"
import { map, groupBy, cloneDeep } from "lodash"
import moment from "moment"

import { getFormatedDate, getParcelEventName } from "shared/utils"

import styles from "./HistoryTable.css"

const HistoryTable = ({ awaitingUpdateMessage, history }) => (
  <table className={[styles.root, "horizontal-headers"].join(" ")}>
    {renderHistoryBlocks(history, awaitingUpdateMessage)}
  </table>
)

const renderRows = historyPart => map(historyPart, (historyItem, index) => {
  const date = getFormatedDate(historyItem.occurrence_datetime.timestamp)
  const parcelStatus = historyItem.description || getParcelEventName(historyItem.status)

  return (
    <tr key={`event_${index}`}>
      <td className={styles.time}>{date.time.slice(0, -3)}</td>
      <td className={styles.event}>
        <span className={styles.status}>{parcelStatus}</span>
        {historyItem.location && (
          <span>
            , <span className={styles.location}>{historyItem.location} </span>
          </span>
        )}
      </td>
    </tr>
  )
})

const renderUpdateMessage = awaitingUpdateMessage => {
  if (!awaitingUpdateMessage) return null

  return (
    <tr className={styles.updateMessage}>
      <td className={styles.time}>
        <span className={styles.dots}>
          <i className="zmdi zmdi-circle"></i>
        </span>
      </td>
      <td className={styles.event}>
        <b>Awaiting update.</b> {awaitingUpdateMessage}
      </td>
    </tr>
  )
}


const renderHistoryBlocks = (history, awaitingUpdateMessage) => {
  const formattedHistory = history.map(historyEntry => {
    const formattedEntry = cloneDeep(historyEntry)
    formattedEntry.occurrence_datetime.iso = historyEntry.occurrence_datetime.iso.slice(0, 10)
    return formattedEntry
  })
  const groupedHistory = groupBy(formattedHistory, "occurrence_datetime.iso")

  return Object.keys(groupedHistory).map((dateISO, index) => {
    const date = moment(dateISO).format("D MMM YYYY")
    const key = moment(dateISO).format()
    return (
      <tbody key={key}>
        <tr>
          <th colSpan="2">{date}</th>
        </tr>
        {index === 0 && renderUpdateMessage(awaitingUpdateMessage)}
        {renderRows(groupedHistory[dateISO])}
      </tbody>
    )
  })
}

HistoryTable.propTypes = {
  history: PropTypes.array.isRequired,
  awaitingUpdateMessage: PropTypes.string,
}

HistoryTable.defaultProps = {
  awaitingUpdateMessage: null,
}

export default HistoryTable



// WEBPACK FOOTER //
// ./src/views/Parcel/components/History/HistoryTable/HistoryTable.js